// Import the plugins
import Rails from "@rails/ujs";

const Uppy = require('@uppy/core');
const XHRUpload = require('@uppy/xhr-upload');
const Dashboard = require('@uppy/dashboard');
require('@uppy/core/dist/style.css');
require('@uppy/dashboard/dist/style.css');

export function setupExcerptsForm() {
    const contributorsContainer = document.getElementById('book_authors_container');
    if (contributorsContainer) {
        const addContainerButton = document.getElementById('publication_metadata_add_contributor');
        if (addContainerButton) {
            addContainerButton.addEventListener("click", (event) => {
                console.log("add event listener");
                handleAddContributor(contributorsContainer);
                event.preventDefault();
            });
        }
    }
}

export function setupContentFileUppy(element) {
    const restrictions = {
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['.epub', 'application/epub+zip', '.lpf', 'application/lpf+zip']
    }

    const options = {
        restrictions: restrictions
    };

    setupUppy(element, options);
}

export function setupImageUppy(element) {
    const restrictions = {
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/jpeg', 'image/png']
    }

    const options = {
        restrictions: restrictions
    };

    setupUppy(element, options);
}

function setupUppy(element, options) {

    let uppyOptions = Object.assign({
        allowMultipleUploads: false,
        autoProceed: true
    }, options);

    let direct_upload_url = document.querySelector("meta[name='direct-upload-url']").getAttribute("content");
    let trigger = element.querySelector('[data-behavior="uppy-trigger"]');
    let form = element.closest('form');
    let field_name = element.dataset.uppy;

    trigger.addEventListener("click", (event) => event.preventDefault());

    const uppy = new Uppy(uppyOptions)
    .use(Dashboard, {
        closeAfterFinish: true,
        trigger: trigger,
        logger: Uppy.debugLogger
    }).use(XHRUpload, { endpoint: direct_upload_url, headers: {'X-CSRF-Token': Rails.csrfToken()}});

    uppy.on('upload-success',  (file, response) => {
        var uploadedFileData = JSON.stringify(response.body.data);
        var hiddenField = form.querySelector(`[name="${field_name}"][type=hidden]`);
        hiddenField.value = uploadedFileData;
    });

    uppy.on('complete', (result) => {
        form.submit();
    });
}

/**
 * @param {String} attributeName
 * @param {String} label
 * @param {String} uniqueId
 */
function genInputField(attributeName, label, uniqueId) {
    return `<div class="medium-6 cell">
            <label for="publication_publication_metadata_attributes_contributors_attributes_${uniqueId}_first_name">${label}</label>
            <input type="text" name="excerpt[publication_metadata_attributes][contributors_attributes][${uniqueId}][${attributeName}]" id="excerpt_publication_metadata_attributes_contributors_attributes_${uniqueId}_${attributeName}">
            </div>`;
}

/**
 * @param {HTMLElement} contributorsContainer
 */
function handleAddContributor(contributorsContainer) {
    const unique_array_id = new Date().getTime().toString();
    let contributorHtml = '<div class="grid-x grid-margin-x">';
    contributorHtml += genInputField("first_name", "First name", unique_array_id);
    contributorHtml += genInputField("last_name", "Last name", unique_array_id);
    contributorHtml += '</div>';

    const node = document.createElement('div');
    node.innerHTML = contributorHtml;

    contributorsContainer.append(node.firstChild);
}
